import { createAction, props } from '@ngrx/store';
import { Document } from '@documents/models/document-type';

export const storeOutcomes = createAction(
  '[Outcome] Store Outcomes',
  props<{ outcomes: any[]; total: number }>(),
);

export const storeStudyIdOutcome = createAction(
  '[Outcome] Store Study ID Outcome',
  props<{ studyId: string }>(),
);

export const storeActiveOutcomeDocument = createAction(
  '[Document] Store Active Outcome Document',
  props<{ document: Document }>(),
);
